import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function initFixedHeaderGSAP(){
  const header = document.querySelector('#weros-header');
  if(!header) return;
  if (header.dataset.staticHeader === "true") return;

  
  const scrollerEl = document.body;

  ScrollTrigger.create({
    scroller: scrollerEl,
    start: 0,
    
    
    end: () => ScrollTrigger.maxScroll(scrollerEl) + 2,
    invalidateOnRefresh: true,
    onUpdate: self => {
      const y = self.scroll();
      const dir = self.direction; 
      const nearTop = y < 16;

      
      if (dir === 1 && y > 8) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }

      
      if (!nearTop && dir === -1) {
        header.classList.add('is-active');
      } else if (nearTop) {
        header.classList.remove('is-active');
      }

      
      if (y > 0) {
        header.classList.add('has-scrolled');
      } else {
        header.classList.remove('has-scrolled');
      }
    }
  });
}
